import { MemberGroups, AccountType } from "shared-types";

export enum UserAttributes {
  FullName = "full_name",
  Email = "email",
  UserIdAgent = "agent_id",
  UserIdCasting = "casting_id",
  UserIdPerformer = "artist_id",
  ProfileId = "profile_id",
  MasterPortalGuid = "sub",
  IdentityProvider = "idp",
  Agencies = "spotlight.Agencies",
  MemberGroup = "spotlight.MemberGroups",
  Subscriptions = "subscriptions",
  Role = "role",
  PublicationCode = "publication",
  AgencyPermissions = "agencyPermissions",
  AgentCanRepYps = "spotlight.CanRepresentYoungPerformers",
}

export const UserGroupAccountTypeMap = {
  [MemberGroups.defaultUser]: AccountType.DefaultUser,
  [MemberGroups.performer]: AccountType.Performer,
  [MemberGroups.graduatePerformer]: AccountType.Performer,
  [MemberGroups.yPerformer]: AccountType.Performer,
  [MemberGroups.agent]: AccountType.Agent,
  [MemberGroups.castingDirector]: AccountType.CastingDirector, // castingDirectorBBC and castingDirectorSearchOnly are considered same role
  [MemberGroups.searchOnlyCD]: AccountType.CastingSearchOnly,
  [MemberGroups.castingBBC]: AccountType.CastingSearchOnly,
};

export const SPOTLIGHT_PORTAL_ID_COOKIE = "spotlight.user";

export const SL_MEMBER_GROUP = "spotlight.MemberGroups";

export const SIGN_IN_CALLBACK_URL = "signin-oidc";

export const POST_LOGIN_REDIRECT_KEY = "postLoginRedirect";

export const INVALID_GRANT_ERROR_CODE = "invalid_grant";

export const OIDC_BROADCAST_CHANNEL_NAME = "oidcBroadcastChannel";

export const OIDC_BROADCAST_UPDATE_USER = "oidcUserUpdated";

export const OIDC_BROADCAST_SIGNIN_USER = "oidcUserSignedIn";

export const OIDC_REFRESH_TOKEN_LOCK_ID = "refreshTokenLock";

export const IDP_PROFILE_CHECKER = "cognito";

export const oidcTabId = `${performance.now()}-${Math.random()}`;

function createOidcBroadcastChannelStub(): BroadcastChannel {
  return {
    name: OIDC_BROADCAST_CHANNEL_NAME,
    onmessage: null,
    onmessageerror: null,
    postMessage: () => {},
    close: () => {},
    addEventListener: () => {},
    removeEventListener: () => {},
    dispatchEvent: () => true,
  } as unknown as BroadcastChannel;
}

export const oidcBroadcastChannel =
  typeof BroadcastChannel !== "undefined"
    ? new BroadcastChannel(OIDC_BROADCAST_CHANNEL_NAME)
    : createOidcBroadcastChannelStub();
